export enum NotificationKind {
  JOB = 'job-notification',
  SELF_CHECKOUT = 'self-checkout-notification',
  INACTIVE_ORGANIZATION = 'inactive-organization-notification',
  PROVISION = 'provision-notification'
}

export interface NotificationListResponseDto {
  _id: string;
  entityId: string;
  entityName: string;
  entityIncrementId?: string;
  message: string;
  read: string;
  kind: NotificationKind;
  triggerUserProfilePictureUrl: string;
  createdAt: string;
}

interface BaseNotification {
  _id: string;
  message: string;
  read: string;
  kind: NotificationKind;
  triggerUserProfilePictureUrl: string;
  createdAt: string;
}

interface JobNotification extends BaseNotification {
  kind: NotificationKind.JOB;
  entityId: string;
  entityName: string;
  entityIncrementId: string;
}

interface SelfCheckoutNotification extends BaseNotification {
  kind: NotificationKind.SELF_CHECKOUT;
  entityId: string;
  entityName: string;
}

interface InactiveOrganizationNotification extends BaseNotification {
  kind: NotificationKind.INACTIVE_ORGANIZATION;
  entityId: string;
  entityName: string;
}

interface ProvisionNotification extends BaseNotification {
  kind: NotificationKind.PROVISION;
  entityId: string;
  entityName: string;
}

export type NotificationListResponseDtoNew = JobNotification | SelfCheckoutNotification | InactiveOrganizationNotification | ProvisionNotification;

export interface BannerCancellationNotificationListResponseDto {
  date: string;
}

export interface BannerNotificationListResponseDto {
  notifications: BannerNotificationResponseDto[];
}

export interface BannerNotificationResponseDto {
  message: string;
}
